<template>
    <div>
        <div class="detail-container">
            <v-text-field
                label="Name *"
                :value="getValue('name')"
                @change="updateValue('name', $event)"
            />

            <v-text-field
                label="Data Name *"
                :value="getValue('dataName')"
                :rules="dataNamesRule"
                @change="updateValue('dataName', $event)"
            />

            <v-text-field
                label="Description"
                :value="getValue('description')"
                @change="updateValue('description', $event)"
            />

            <v-text-field
                label="Default Value"
                :value="getValue('defaultValue')"
                @change="updateValue('defaultValue', $event)"
            />

            <v-text-field
                v-if="selectedElm=='STRING'"
                label="Min Length"
                type="number"
                min="0"
                :value="getValue('minLength')"
                @change="updateValue('minLength', $event)"
            />

            <v-text-field
                v-if="selectedElm=='STRING'"
                label="Max Length"
                type="number"
                min="0"
                :value="getValue('maxLength')"
                @change="updateValue('maxLength', $event)"
            />

            <v-text-field
                v-if="selectedElm=='INTEGER' || selectedElm=='FLOAT'"
                label="Min Value"
                type="number"
                :value="getValue('minValue')"
                @change="updateValue('minValue', $event)"
            />

            <v-text-field
                v-if="selectedElm=='INTEGER' || selectedElm=='FLOAT'"
                label="Max Value"
                type="number"
                :value="getValue('maxValue')"
                @change="updateValue('maxValue', $event)"
            />

            <v-autocomplete
                v-if="selectedElm=='STRING' || selectedElm=='INTEGER' || selectedElm=='FLOAT'"
                label="Measurement Unit"
                :items="measurementUnits"
                item-text="name"
                item-value="id"
                :value="getValue('measurementUnitId')"
                @change="updateValue('measurementUnitId', $event)"
            />

            <v-textarea
                v-if="selectedElm=='CHECKBOX' || selectedElm=='DROPDOWN'"
                label="Possible Values"
                :value="getValue('possibleValues')"
                hint="Enter a new value with comma (,) "
                @change="updateValue('possibleValues', $event)"
            />

            <v-checkbox 
                color="primary"
                label="Required"
                :value="getValue('isRequired')"
                @change="updateValue('isRequired', $event)"
            />

            <v-btn color="primary" class="visibility-btn" @click="openDialog('Visibility')">Visibility Rules</v-btn>
            <v-btn color="primary" class="requirement-btn" @click="openDialog('Requirement')">Requirement Rules</v-btn>
        </div>

        <!-- Visibility & Requirement Dialog -->
        <general-dialog :dialog.sync="isDialog" :width="dialogWidth" :header="header">
            <template #content>
                Match 
                <b-form-select
                    v-model="matchValue"
                    class="match-container"
                    placeholder="Value"
                    :options="matchOpts"
                />
                of the following conditions {{ dialogDescription }} 

                <div v-for="(condition, index) in conditions" :key="'cond'+index" class="condition-dialog-container">
                    <b-form-select 
                        v-model="condition.formId" 
                        placeholder="Form Element" 
                        :options="visibilityOpts"
                        :value-field="'formId'"
                        :text-field="'name'"
                        @change="uniqueVisibilityOpt($event, index)"
                    />
                    <b-form-select 
                        v-model="condition.comparatorTypeId" 
                        placeholder="Operator" 
                        :options="comparatorTypeOpts"
                        :value-field="'id'"
                        :text-field="'name'"
                    />
                    <b-form-input 
                        v-if="condition.selectedFormCdoe=='STRING' || condition.selectedFormCdoe=='INTEGER' || condition.selectedFormCdoe=='FLOAT' || condition.selectedFormCdoe=='DATE' || condition.selectedFormCdoe=='DATETIME'"
                        v-model="condition.value" 
                        placeholder="Value"
                    />
                    <b-form-select 
                        v-if="condition.selectedFormCdoe=='BOOL'"
                        v-model="condition.value" 
                        placeholder="Value"
                        :options="booleanOpts"
                    />
                    <b-form-select 
                        v-if="condition.selectedFormCdoe=='CHECKBOX' || condition.selectedFormCdoe=='DROPDOWN'"
                        v-model="condition.value"
                        placeholder="Value"
                        :options="getConditionValues(condition.conditionOpts)"
                    />
                    <div class="action-container">
                        <div class="round-btn add-btn" @click="addCondtion(index)"><i class="fas fa-plus" /></div>
                        <div class="round-btn remove-btn" @click="removeCondition(index)"><i class="fa fa-times" /></div>
                    </div>
                </div>
            </template>
            <template #action>
                <v-btn color="agrinome_primary" dark @click="saveVisibility()">Save</v-btn>
            </template>
        </general-dialog>
    </div>
</template>

<script>
export default {
    name: "CustomFormInputParam",
    props: [ "list2", "selectedElm", "selectedIdx", "isGroupSelected", "selectedGroupIdx" ],
    data() {
        return {
            isDialog: false,
            comparatorTypeOpts: [],

            measurementUnits: [],

            booleanOpts: [
                { value: false, text: false },
                { value: true, text: true }
            ],
            dialogWidth: "50%",
            matchOpts: [
                { value: "All", text: "All" },
                { value: "Any", text: "Any" }
            ],
            matchValue: "All",
                
            conditions: [ { id: 1, formId: null, comparatorTypeId: null, value: null, selectedFormCdoe: null, dataName: null } ],
            nextConditionId: 2,
            visibilityOpts: [],

            allDataNames: [],
            dataNamesRule: [
                v => !!v || "Data name is required",
                v => this.checkIsUniqueRules(v),
            ],
            collisionCount: 0,

            dialogCategory: null,
            dialogDescription: "to display this element.",
        };
    },
    computed: {
        header() {
            return this.dialogCategory + " Condition";
        }
    },
    mounted() {
        this.getAllMeasurementUnit();
        this.getAllComparatorType();
    },
    methods: {
        checkIsUniqueRules(dataField) {
            // Flatten the data
            var dataNamesArr = [];
            this.list2.forEach(item => {
                dataNamesArr.push(item);
                if (item.childrenCustomFields) {
                    dataNamesArr.push(...item.childrenCustomFields);
                }
            });

            // Check is the dataname unique
            var isUnique = true;
            var collisionItem = {};
            this.collisionCount = 0;
            dataNamesArr.forEach(item => {
                if (item.dataName && item.dataName === dataField) {
                    this.collisionCount++;
                    if (this.collisionCount > 1) {
                        item.isDataNameDuplicate = true;
                        isUnique = false;
                        collisionItem = item;
                    }
                    else {
                        item.isDataNameDuplicate = false;
                    }
                }
            });
            return isUnique || "This data name is used";
        },
        getValue(type) {
            this.collisionCount = 0;
            if (typeof(this.selectedIdx) != null && this.list2[this.selectedIdx]) {
                if (this.isGroupSelected) return this.list2[this.selectedIdx].childrenCustomFields[this.selectedGroupIdx][type];
                else return this.list2[this.selectedIdx][type];
            }
            else return null;
        },
        updateValue(type, event) {
            if (this.list2[this.selectedIdx]) {
                if (this.isGroupSelected) this.list2[this.selectedIdx].childrenCustomFields[this.selectedGroupIdx][type] = event;
                else this.list2[this.selectedIdx][type] = event;

                this.$forceUpdate();
            }
        },
        openDialog(category) {
            this.isDialog = true;
            this.dialogCategory = category;
            this.dialogDescription = category == "Visibility" ? "to display this element." : "to make this field required.";
            this.getDialogOpts();
        },
        closeDialog() {
            this.isDialog = false;
            this.conditions = [ { id: 1, formId: null, comparatorTypeId: null, value: null, selectedFormCdoe: null, dataName: null } ];
            this.nextConditionId = 2;
        },
        saveVisibility() {
            var rulesType = this.dialogCategory == "Visibility" ? "customFieldVisibilityRules" : "customFieldRequirementRules";
            var matchType = this.dialogCategory == "Visibility" ? "visibilityMatchCondition" : "requirementMatchCondition";
            if (this.list2[this.selectedIdx] && event) {
                if (this.isGroupSelected) {
                    this.list2[this.selectedIdx].childrenCustomFields[this.selectedGroupIdx][rulesType] = this.conditions;
                    this.list2[this.selectedIdx].childrenCustomFields[this.selectedGroupIdx][matchType] = this.matchValue;
                }
                else {
                    this.list2[this.selectedIdx][rulesType] = this.conditions;
                    this.list2[this.selectedIdx][matchType] = this.matchValue;
                }
            }

            this.closeDialog();
        },
        getDialogOpts() {
            var list = JSON.parse(JSON.stringify(this.list2));

            // Remove the selected form item in visibilisty rules options
            if (this.isGroupSelected) {
                list[this.selectedIdx].childrenCustomFields.splice(this.selectedGroupIdx, 1);
            }
            else list.splice(this.selectedIdx, 1);

            // Reaarange the visibility rule option by combining all the childrenCustomFields params
            var listArr = [];
            list.forEach((item, index) => {
                if (item.code === "SECTION") {
                    item.childrenCustomFields.forEach(groupItem => {
                        if (this.checkIsIncludeInRules(groupItem)) listArr.push(groupItem);
                    });
                }
                if (this.checkIsIncludeInRules(item)) listArr.push(item);
            });

            listArr.unshift({ formId: "null", name: "Select a form element" });
            this.visibilityOpts = listArr;
        },
        checkIsIncludeInRules(item) {
            if (item.code !== "LABEL" && item.code !== "PHOTOS" && item.code !== "VIDEOS" && item.code !== "AUDIO" && item.code !== "BARCODE" && item.code !== "SIGNATURE" && item.code !== "SECTION") {
                return true;
            }
            else return false;
        },
        addCondtion() {
            this.conditions.push({
                id: this.nextConditionId++, 
                formId: null, 
                comparatorTypeId: null, 
                value: null,
                selectedFormCdoe: null,
                dataName: null 
            });
        },
        removeCondition(index) {
            if (this.conditions.length > 1) {
                this.conditions.splice(index, 1);
            }
        },
        uniqueVisibilityOpt(event, index) {
            // Disbaled true for selected option
            this.visibilityOpts.forEach(option => {
                if (option.formId === event) {
                    option.disabled         = true;
                    this.conditions[index].selectedFormCdoe = option.code;
                    this.conditions[index].dataName         = option.dataName;
                    this.conditions[index].inputTypeId      = option.inputTypeId;
                    if ((option.code == "CHECKBOX" && option.possibleValues) || (option.code == "DROPDOWN" && option.possibleValues)) {
                        this.conditions[index].conditionOpts = option.possibleValues;
                    }
                }
            });
        },
        getConditionValues(possibleValues) {
            if (possibleValues) {
                var tempArr = possibleValues.split(",");
                return tempArr;
            }
            else return [];
        },
        getAllMeasurementUnit() {
            var self = this;
            axios({
                method: "GET",
                url: "MeasurementUnit/GetAllForDropdown"
            })
                .then(function (response) {
                    self.measurementUnits = response.data.result;
                });
        },
        getAllComparatorType() {
            var self = this;
            axios({
                method: "GET",
                url: "ComparatorType/GetAllForDropdown"
            })
                .then(function (response) {
                    self.comparatorTypeOpts = response.data.result;
                    self.comparatorTypeOpts.unshift({ id: "null", name: "Select a comparator" });
                    // shift { id: null, text: 'Select an Operator' },
                });
        }
    }
};
</script>

<style lang="css" scoped>
.detail-container{
    padding: 0.1rem 0 1rem 0;
}
.visibility-btn{
    width: 100%;
    margin: 16px 0 8px 0;
}
.requirement-btn{
    width: 100%;
    margin: 0;
}
.condition-dialog-container{
    margin-top: 10px;
    display: grid;
    grid-template-columns: 2fr 1.5fr 1fr 1fr;
    grid-gap: 10px;
}
.action-container{
    display: flex;
    justify-content: center;
}
.match-container{
    display: inline-block;
    width: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/Configurations/CustomFormConfiguration/CustomFormInputParam.vue